import ColorfulCalendar from './colorful-calendar';
export default ColorfulCalendar;
